export const getters = {
	conseillers: state => state.conseillers
}



// WEBPACK FOOTER //
// ./src/store/modules/Conseillers/getters.js